import type { SVGProps } from "react";
export default function SvgResearchApp(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 164 188"
			{...props}
		>
			<foreignObject width={146.669} height={174.669} x={0} y={13.3311}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1094_1404_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_ddddi_1094_1404)">
				<path
					fill="url(#paint0_linear_1094_1404)"
					fillOpacity={0.6}
					d="M73.336 31.331h-.003C54.923 31.331 40 46.255 40 64.664v.003C40 83.077 54.924 98 73.333 98h.003c18.41 0 33.333-14.924 33.333-33.333v-.003c0-18.41-14.924-33.333-33.333-33.333"
				/>
				<path
					stroke="url(#paint1_linear_1094_1404)"
					d="M73.333 31.831h.003c18.133 0 32.833 14.7 32.833 32.833v.003c0 18.133-14.7 32.833-32.833 32.833h-.003C55.2 97.5 40.5 82.8 40.5 64.667v-.003l.01-.848c.443-17.46 14.516-31.532 31.975-31.974z"
				/>
			</g>
			<foreignObject width={150.22} height={178.22} x={11.2412} y={-1.46875}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1094_1404_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_ddddi_1094_1404)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M86.351 16.531c19.378 0 35.11 15.732 35.11 35.11s-15.732 35.11-35.11 35.11-35.11-15.733-35.11-35.11c0-19.378 15.732-35.11 35.11-35.11"
				/>
				<path
					stroke="url(#paint2_linear_1094_1404)"
					strokeOpacity={0.5}
					d="M86.352 17.031c19.101 0 34.609 15.508 34.609 34.61 0 19.1-15.508 34.61-34.61 34.61-19.101 0-34.61-15.509-34.61-34.61 0-19.102 15.51-34.61 34.61-34.61Z"
				/>
			</g>
			<path
				fill="#FAFF00"
				stroke="url(#paint3_linear_1094_1404)"
				d="M86.355 40.907c5.93 0 10.738 4.808 10.738 10.739 0 5.93-4.807 10.738-10.739 10.738-5.93 0-10.738-4.808-10.738-10.739 0-5.93 4.808-10.738 10.739-10.738Z"
			/>
			<path
				fill="#F5FCFF"
				d="M86.351 78.013c-14.536 0-26.36-11.825-26.36-26.361s11.824-26.361 26.36-26.361c14.537 0 26.362 11.825 26.362 26.361s-11.825 26.361-26.362 26.361m0-48.07c-11.971 0-21.709 9.74-21.709 21.709s9.738 21.71 21.71 21.71c11.971 0 21.709-9.741 21.709-21.71s-9.74-21.71-21.71-21.71"
			/>
			<path
				stroke="url(#paint4_linear_1094_1404)"
				strokeOpacity={0.5}
				d="M86.352 25.791c14.26 0 25.861 11.601 25.861 25.861s-11.602 25.86-25.861 25.86-25.862-11.6-25.862-25.86 11.601-25.861 25.862-25.861Zm0 3.651c-12.248 0-22.21 9.966-22.21 22.21s9.962 22.21 22.21 22.21c12.247 0 22.208-9.965 22.209-22.21 0-12.244-9.965-22.21-22.21-22.21Z"
			/>
			<foreignObject width={119.976} height={147.976} x={44.0283} y={-4}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_2_1094_1404_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter2_ddddi_1094_1404)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M123.83 22.563a2.01 2.01 0 0 0-1.926-1.196l-5.517.25.25-5.517a2.01 2.01 0 0 0-3.427-1.512l-8.74 8.74a2 2 0 0 0-.587 1.42v6.083L84.71 50.005a2.325 2.325 0 1 0 3.289 3.289l19.173-19.174h6.084a2 2 0 0 0 1.42-.589l8.74-8.74a2.01 2.01 0 0 0 .417-2.231z"
				/>
				<path
					stroke="url(#paint5_linear_1094_1404)"
					strokeOpacity={0.5}
					d="M113.563 14.941a1.51 1.51 0 0 1 1.675-.314c.536.238.882.758.901 1.334l-.001.116-.25 5.518-.026.547.547-.026 5.518-.25a1.51 1.51 0 0 1 1.445.898l.038.086c.202.55.07 1.17-.348 1.587l-8.74 8.74a1.5 1.5 0 0 1-1.066.443h-6.291l-.147.147L87.646 52.94a1.82 1.82 0 0 1-1.291.536 1.825 1.825 0 0 1-1.291-3.117l19.32-19.32v-6.291c0-.4.157-.785.439-1.067z"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_1094_1404"
					x1={73.5046}
					x2={73.5046}
					y1={31.3311}
					y2={97.9997}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1094_1404"
					x1={73.3346}
					x2={48.7186}
					y1={32.0612}
					y2={86.7656}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1094_1404"
					x1={86.3511}
					x2={86.3511}
					y1={16.5312}
					y2={86.7506}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_1094_1404"
					x1={76.2454}
					x2={102.748}
					y1={39.7147}
					y2={52.8914}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" stopOpacity={0.2} />
					<stop offset={1} stopColor="#F5FCFF" stopOpacity={0.05} />
				</linearGradient>
				<linearGradient
					id="paint4_linear_1094_1404"
					x1={86.3514}
					x2={86.3514}
					y1={25.291}
					y2={78.013}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<linearGradient
					id="paint5_linear_1094_1404"
					x1={104.016}
					x2={104.016}
					y1={14}
					y2={53.9752}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1094_1404_clip_path" transform="translate(0 -13.331)">
					<path d="M73.336 31.331h-.003C54.923 31.331 40 46.255 40 64.664v.003C40 83.077 54.924 98 73.333 98h.003c18.41 0 33.333-14.924 33.333-33.333v-.003c0-18.41-14.924-33.333-33.333-33.333" />
				</clipPath>
				<clipPath id="bgblur_1_1094_1404_clip_path" transform="translate(-11.241 1.469)">
					<path d="M86.351 16.531c19.378 0 35.11 15.732 35.11 35.11s-15.732 35.11-35.11 35.11-35.11-15.733-35.11-35.11c0-19.378 15.732-35.11 35.11-35.11" />
				</clipPath>
				<clipPath id="bgblur_2_1094_1404_clip_path" transform="translate(-44.028 4)">
					<path d="M123.83 22.563a2.01 2.01 0 0 0-1.926-1.196l-5.517.25.25-5.517a2.01 2.01 0 0 0-3.427-1.512l-8.74 8.74a2 2 0 0 0-.587 1.42v6.083L84.71 50.005a2.325 2.325 0 1 0 3.289 3.289l19.173-19.174h6.084a2 2 0 0 0 1.42-.589l8.74-8.74a2.01 2.01 0 0 0 .417-2.231z" />
				</clipPath>
				<filter
					id="filter0_ddddi_1094_1404"
					width={146.669}
					height={174.669}
					x={0}
					y={13.3311}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1404" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1404"
						result="effect2_dropShadow_1094_1404"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1404"
						result="effect3_dropShadow_1094_1404"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1404"
						result="effect4_dropShadow_1094_1404"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1404" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1404" />
				</filter>
				<filter
					id="filter1_ddddi_1094_1404"
					width={150.22}
					height={178.22}
					x={11.2412}
					y={-1.46875}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1404" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1404"
						result="effect2_dropShadow_1094_1404"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1404"
						result="effect3_dropShadow_1094_1404"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1404"
						result="effect4_dropShadow_1094_1404"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1404" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1404" />
				</filter>
				<filter
					id="filter2_ddddi_1094_1404"
					width={119.976}
					height={147.976}
					x={44.0283}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1404" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.466667 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1404"
						result="effect2_dropShadow_1094_1404"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1404"
						result="effect3_dropShadow_1094_1404"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1404"
						result="effect4_dropShadow_1094_1404"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1404" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1404" />
				</filter>
			</defs>
		</svg>
	);
}
